import React from "react";
import TableOfContents from "../../TableOfContents/TableOfContents.tsx";
import TocMobile from "../../ToCTelephone/TocTelephone.tsx";
// import the corresponding css file
import "./EC20Notebook.css";
// import the separated file related to the component
import TextEC20Notebook from "./TextEC20Notebook.jsx";

const EC20Notebook = () => {
  // headingData is used in the TableOfContents
  // every title (h2, h2, etc) used in the separated file of the component should be in the table
  const headingsData = [
    {
      // the level 2 is the most important level you can have (the basic one)
      level: 2,
      // the text will be displayed in the table of contents
      text: "Introduction",
      // the id should be the same as the one used in the separated file of the component else the name of the title would not be displayed as wanted
      // do not use space for the id
      id: "Intro-EC20_e",
    },
    {
      level: 2,
      text: "Transformation of EC20 plasmids",
      id: "Transformation-EC20_e",
    },
    {
      level: 2,
      text: "Primary culture of EC20-transformed bacteria",
      id: "PrimaryCulture-EC20_e",
    },
    {
      level: 2,
      text: "Testing the amplicilline plates",
      id: "Ampplate-test_e",
    },
    {
      level: 2,
      text: "Glycerol stock of DH5α and BL21 cells with EC20",
      id: "Glycerol-stock-EC20_e",
    },
    {
      level: 2,
      text: "Miniprep of DH5α cells with EC20",
      id: "Miniprep-EC20_e",
    },
    {
      level: 2,
      text: "Proteinase K experiment with EC20",
      id: "Proteinase-K-EC20_e",
    },
    {
      level: 2,
      text: "Testing of Proteinase K on GFP",
      id: "Proteinase-K-GFP_e",
    },
    {
      level: 2,
      text: "Transformation of His tag plasmid",
      id: "Transformation-His_e",
    },
    {
      level: 2,
      text: "Protein extraction of EC20 and Coomassie blue staining",
      id: "Protein-Extraction_e",
    },
    {
      level: 2,
      text: "Protein extraction of EC20 and His Control",
      id: "Protein-Extraction-2_e",
    },
    {
      level: 2,
      text: "Urea DTT experiment 1",
      id: "Urea-DTT-1_e",
    },
    {
      level: 2,
      text: "Zinc Experiment 1",
      id: "Zinc1_e",
    },
    {
      level: 2,
      text: "Zinc Experiment 2",
      id: "Zinc2_e",
    },
    {
      level: 2,
      text: "Cadmium Experiment 1",
      id: "Cadmium1_e",
    },
    {
      level: 2,
      text: "Cadmium Experiment 2",
      id: "Cadmium2_e",
    },
    {
      level: 2,
      text: "Urea DTT experiment 2",
      id: "Urea-DTT-2_e",
    },
  ];

  return (
    <>
      {/* Display the content of the page on the entire viewport */}
      <div>
        {/* divide the section in columns */}
        <div className="grid grid-cols-12 gap-4" style={{ marginLeft: "50px" }}>
          {/* section on the left (=Table of content) */}
          <div className="hidden md:block col-span-4 ml-6 order-2 md:order-1">
            {/* it will stay visible on the viewport */}
            <div className="sticky top-4 scrollable">
              {/* call the Table of contents with headingData modified above */}
              <TableOfContents headings={headingsData} />
            </div>
          </div>
          {/* main content which is a separated file you call and it is displayed on the right of the section above */}
          <main className="prose col-span-12 md:col-span-8 order-1 md:order-2">
            <TextEC20Notebook />
          </main>
          {/* display the table of content when the viewport is too small */}
          <div className="md:hidden col-span-12 order-2 TOCstyle">
            <TocMobile headings={headingsData} />
          </div>
        </div>
      </div>
    </>
  );
};

// don't forget to change the name of the component you're exporting
export default EC20Notebook;
